<template>
  <div class="dashboard-container test123">
    <component :is="currentRole" />
    <div style="margin-top:5px;clear:both;">
      <div v-if="hasPermissionForQuickSearch" class="app-container" style="width:25%;float:left">
        <quick-search />
      </div>
      <div v-if="hasPermissionForOrderLineStatusSummary" class="app-container" style="float:left">
        <order-line-status-summary />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import memberHome from './member';
import visitorHome from './visitor';
import quickSearch from './components/QuickSearch';
import orderLineStatusSummary from './components/OrderLineStatusSummary';
import { hasReadPermissionForCode } from '@/utils/permission';

export default {
  components: { memberHome, visitorHome, quickSearch, orderLineStatusSummary },
  data() {
    return {
      currentRole: 'visitorHome'
    };
  },
  computed: {
    ...mapGetters(['userId']),
    hasPermissionForQuickSearch() {
      return (
        hasReadPermissionForCode('Store', this.$store.getters.permissions) &&
        hasReadPermissionForCode('Order', this.$store.getters.permissions)
      );
    },
    hasPermissionForOrderLineStatusSummary() {
      return hasReadPermissionForCode('OrderLineStatusSummary', this.$store.getters.permissions);
    }
  },
  created() {
    if (this.userId) {
      this.currentRole = 'memberHome';
    } else {
      this.currentRole = 'visitorHome';
    }
  }
};
</script>
